import { ReactNode } from "react"
import cn from "classnames"

interface MenuProps {
    className?: string
    children: ReactNode
}

export function Menu(props: MenuProps) {
    return (
        <nav className={cn("desktop-navigation", "mgr-3", props.className)}>{props.children}</nav>
    )
}
